<template>
  <SideNav />

  <section class="position-relative">
    <div
      class="page-header min-vh-60"
      style="background-image: url('assets/img/read.jpg');"
      loading="lazy"
    >
      <span class="mask bg-gradient-dark opacity-5" />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center mx-auto">
            <h2 class="text-white mb-3 fadeIn1 fadeInBottom ">
              How can we help you?
            </h2>
            <p class="text-white mb-6 fadeIn2 fadeInBottom ">
              若您想獲得昀揚科技最新產品訊息，<br>或對昀揚科技產品有想要更深入的了解，可與我們聯繫。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="card card-body shadow-xl mx-2 mx-md-4 mt-n6 mb-4">
    <div class="container px-0">
      <div class="row mt-sm-0 mt-md-5 fadeIn3 fadeInBottom ">
        <div class="col-lg-3 col-4 position-relative ms-lg-auto">
          <div class="p-md-3 text-center border-right-after">
            <i class="material-icons text-gradient text-warning text-5xl mb-3">email</i>
            <h6 class="mb-0">
              Email
            </h6>
            <p class="text-dark font-weight-normal">
              service@cloudraise.com
            </p>
          </div>
        </div> 
        <div class="col-lg-3 col-4 position-relative">
          <div class="p-md-3 text-center border-right-after">
            <i class="material-icons text-gradient text-warning text-5xl mb-3">call</i>
            <h6 class="mb-0">
              Phone
            </h6>
            <p class="text-dark font-weight-normal">
              (02) <br class="d-md-none">29992891
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-4 me-lg-auto">
          <div class="p-md-3 text-center">
            <i class="material-icons text-gradient text-warning text-5xl mb-3">fax</i>
            <h6 class="mb-0">
              FAX
            </h6>
            <p class="text-dark font-weight-normal">
              (02) <br class="d-md-none">29992897
            </p>
          </div>
        </div>
      </div>
    </div>

    <p />
    <p />
    <p />
    <p />

    <!--
    <section class="py-md-7 py-5  ">
      <div class="px-md-5">
        <div class="row align-items-center fadeIn4 fadeInBottom mb-5 mb-md-0">
          <div class="col-lg-8 mx-auto text-center">
            <div class="mb-md-5">
              <h3>聯絡我們</h3>
              <p>
                請留下您的聯絡資料，將有專人為您服務。
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <div class="card card-plain">
              <form
                id="contact-form"
                method="post"
                autocomplete="off"
              >
                <div class="">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="input-group input-group-static mb-4">
                        <label>姓名<span class="text-danger ms-1">*</span></label>
                        <input
                          type="text"
                          class="form-control pe-4"
                          placeholder="請輸入姓名"
                        >
                        <span class="input-group-text"><i class="material-icons">person</i></span>
                      </div>
                    </div>                   
                    <div class="col-md-6">
                      <div class="input-group input-group-static mb-4">
                        <label>聯絡電話<span class="text-danger ms-1">*</span></label>
                        <input
                          type="text"
                          class="form-control pe-4"
                          placeholder="請輸入聯絡電話"
                        >
                        <span class="input-group-text"><i class="material-icons">phone</i></span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group input-group-static mb-4">
                        <label>Email<span class="text-danger ms-1">*</span></label>
                        <input
                          type="email"
                          class="form-control pe-4"
                          placeholder="請輸入Email"
                        >
                        <span class="input-group-text"><i class="material-icons">email</i></span>
                      </div>
                    </div>                    

                    <div class="col-md-6">
                      <div class="input-group input-group-static mb-4">
                        <label>已購買昀揚科技產品?<span class="text-danger ms-1">*</span></label>
                        <select
                          class="form-control"
                          id="exampleFormControlSelect1"
                        >
                          <option>請選擇</option>
                          <option>尚未購買</option>
                          <option>題庫編輯系統</option>
                          <option>地圖編輯系統</option>
                        </select>
                        <span class="input-group-text"><i class="material-icons">shop</i></span>
                      </div>
                    </div>
                 
                    <div class="col-12 form-group mb-4">
                      <div class="input-group input-group-static mb-4">
                        <label>需求描述<span class="text-danger ms-1">*</span></label>
                        <textarea
                          name="message"
                          class="form-control"
                          id="message"
                          rows="6"
                          placeholder="請描述您的需求"
                        />
                      </div>
                    </div>                  
                    <div class="col-md-6">
                      <div class="input-group input-group-static">
                        <label>驗證碼<span class="text-danger ms-1">*</span></label>
                        <input
                          type="text"
                          class="form-control pe-7"
                          placeholder="請輸入驗證碼"
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="nput-group input-group-static mt-3">
                        <img
                          src="assets/img/checkimg.png"
                          style="height: 40px;"
                        >
                        <button
                          class="btn btn-icon btn-2 btn-warning mb-0 py-2 px-3 ms-2"
                          type="button"
                        >
                          <span class="btn-inner--icon">
                            <i class="material-icons">restart_alt</i>
                          </span>
                        </button>
                      </div>
                    </div>
                    
                    <div class="row mt-4">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                          checked=""
                        >
                        <label
                          class="custom-control-label"
                          for="customCheck1"
                        >同意昀揚科技使用資訊聯繫您</label>
                      </div>                      
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                          checked=""
                        >
                        <label
                          class="custom-control-label"
                          for="customCheck1"
                        ><a
                          href="privacy.html"
                          class="text-info text-decoration-underline "
                        >個資保護聲明</a></label>
                      </div>
                     
                      <div class="col-md-12 text-center">
                        <p class="text-danger">
                          避免誤會提醒：如果取消勾選同意，送出訊息按鈕要反灰喔（阿賢記得刪除這行字）
                        </p>
                        <button
                          type="button"
                          class="btn bg-gradient-warning mt-4"
                          data-bs-toggle="modal"
                          data-bs-target="#contact"
                        >
                          送出訊息
                        </button>
                      </div>
                    </div> 
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    -->
  </div>

  <Footer />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //NavBar,
    // Settings,
    Footer,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(page){
      if(router.currentRoute.value.name == page) { return; }
      router.push(page);
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
